// Keep the current URL and rebuild all tenant-dependent providers and menus.
export function reloadCurrentPage() { window.location.reload(); }
